export enum CustomerTypes {
  Customer = 'customer', // means that customer payed for student
  Student = 'student' // means that student payed for himself
}
